import $ from 'jquery';
import merge from 'lodash/merge';

export const scrollTo = (userArguments = {}) => {
  var defaultOptions = {
    duration: 200,
    elementId: null,
    containerSelector: 'html, body',
    width: null,
    secondContainerSelector: null,
    manuallOffset: 0
  };

  var options = merge(defaultOptions, userArguments);
  if (options.width) {
    const isMobileMedium = options.width >= 640 && options.width <= 959;
    const isMobileSmall = options.width < 640;
    var container = null;
    if (options.width <= 959) {
      if (options.secondContainerSelector) {
        container = options.secondContainerSelector;
      }
    }
  }

  if (!container) {
    container = options.containerSelector;
  }

  if (container) {
    $(container).animate({
      scrollTop: $('#' + options.elementId).offset().top + options.manuallOffset
    }, options.duration)
  }

}
